var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInquiryHomePageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.652 3.026A5.455 5.455 0 0143.1 8.462l.042 20.1h5.732c2.602.002 6.065.003 10.68.003A5.457 5.457 0 0165 34.012V55.92a5.454 5.454 0 01-5.447 5.447H52.17v1.816c0 1.357-1.43 2.223-2.628 1.624l-6.879-3.44H30.382a5.453 5.453 0 01-5.447-5.447V35.96l-3.028-.01-6.776 5.083c-1.19.892-2.905.045-2.905-1.453V35.95H8.473a5.453 5.453 0 01-5.447-5.447V8.472a5.453 5.453 0 015.447-5.446h29.18z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.579 31.591V53.5a5.453 5.453 0 01-5.447 5.447h-7.384v1.816c0 1.357-1.43 2.223-2.627 1.624l-6.88-3.44h-12.28a5.453 5.453 0 01-5.447-5.446V32.934l12.762.038a4.837 4.837 0 004.842-4.851l-.004-1.978c2.005-.006 6.547.001 17.018.001a5.454 5.454 0 015.447 5.447z",
    fill: "#ED1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.678 6.04A5.455 5.455 0 0035.231.606H6.052A5.453 5.453 0 00.605 6.052v22.03a5.453 5.453 0 005.447 5.446h3.753v3.631c0 1.498 1.715 2.345 2.905 1.453l6.776-5.082 15.791.047a5.444 5.444 0 005.447-5.457l-.046-22.08z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.052A6.058 6.058 0 016.052 0h29.179a6.06 6.06 0 016.052 6.04l.046 22.078a6.049 6.049 0 01-6.052 6.065l-15.59-.047-6.614 4.96c-1.586 1.19-3.874.063-3.874-1.937v-3.026H6.052A6.058 6.058 0 010 28.081V6.052zM6.052 1.21A4.848 4.848 0 001.21 6.052v22.03a4.848 4.848 0 004.842 4.84h4.358v4.237c0 .996 1.143 1.564 1.936.968l6.939-5.203h.203l15.789.048a4.838 4.838 0 004.841-4.851l-.045-22.079A4.85 4.85 0 0035.23 1.21H6.052z",
    fill: "#ED1B2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.31 8.655c-1.809-.99-4.007-.866-5.88.331a1.816 1.816 0 101.957 3.06c.76-.487 1.534-.56 2.18-.205a1.818 1.818 0 01-.612 3.392 2.425 2.425 0 00-2.073 2.395v1.133a1.816 1.816 0 003.632 0v-.19c2.13-.757 3.63-2.805 3.63-5.136a5.448 5.448 0 00-2.833-4.78zM20.577 26.145a1.816 1.816 0 100-3.632 1.816 1.816 0 000 3.631z",
    fill: "#ED1B2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.592 40.67H53.38a1.816 1.816 0 000-3.632H31.592a1.816 1.816 0 000 3.631zM53.38 44.3H31.592a1.816 1.816 0 000 3.632H53.38a1.816 1.816 0 000-3.632z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.58 31.591V53.5a5.454 5.454 0 01-5.447 5.447h-7.384v1.816c0 1.357-1.43 2.223-2.628 1.624L42.547 60.1V26.14c2.668 0 7.118.004 14.586.004a5.453 5.453 0 015.447 5.446z",
    fill: "#000",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.724 28.12a5.444 5.444 0 01-5.447 5.458l-14.7-.045V.605h14.654a5.456 5.456 0 015.447 5.436l.046 22.079z",
    fill: "#000"
  })));
}

export default SvgInquiryHomePageIcon;